<template>
    <div
            class="input-file"
            :class="{
                'input-file_mobile': $vuetify.breakpoint.xsOnly
            }"
    >
        <div class="input-file__items">
            <div
                    v-for="(item, key) in localValue"
                    :key="key"
                    class="input-file__item"
                    :style="{
                        width: itemWidth+'px',
                        height: itemHeight+'px'
                    }"
            >
                <img
                        v-if="item.url !== null"
                        :src="fileStoreDomain + item.url"
                        class="input-file__img"
                >
                <v-progress-circular
                        v-if="item.loading"
                        :value="item.loadingValue"
                        color="primary"
                ></v-progress-circular>
                <v-btn
                        v-if="!item.loading"
                        fab
                        small
                        class="input-file__close"
                        @click="() => {
                            localValue.splice(key, 1);
                            sendValue();
                        }"
                        elevation="0"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </div>
        <input
                v-show="false"
                type="file"
                :multiple="multiple"
                ref="input"
                @change="change($event)"
                :accept="accept"
                :value="model"
        >
        <v-btn
                v-if="multiple || (!multiple && localValue.length === 0)"
                color="primary"
                class="input-file__btn"
                :class="{
                    'mt-3': localValue.length > 0
                }"
                :small="!isMobile"
                @click="$refs.input.click()"
                elevation="0"
        >{{ $t(btnLabel) }}</v-btn>
        <div
                v-if="errorMessages.length > 0"
                class="input-file__msg"
        >
            {{ errorMessages[0] }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: [String, Array],
            multiple: {type: Boolean, default: false},
            errorMessages: null,
            btnLabel: {type: String, default: 'msg.attachFile'},
            type: {type: String, default: null},
            itemWidth: {type: Number, default: 100},
            itemHeight: {type: Number, default: 100}
        },
        data() {
            return {
                localValue: [],
                model: null
            }
        },
        computed: {
            accept() {
                if (this.type === 'image') return 'image/jpeg,image/png,image/gif';
                return '';
            },
            fileStoreDomain() {
                return process.env.VUE_APP_FILE_STORE_SCHEMA + process.env.VUE_APP_FILE_STORE_DOMAIN;
            }
        },
        watch: {
            value(v) {
                this.parseValue(v);
            }
        },
        methods: {
            parseValue(v) {
                this.localValue = [];
                if (v === undefined || v === null) return;
                if (this.multiple) {
                    v.forEach(item => {
                        this.localValue.push({
                            file: {},
                            loading: false,
                            loadingValue: 0,
                            url: item,
                        });
                    });
                } else {
                    if (v !== null) {
                        this.localValue.push({
                            file: {},
                            loading: false,
                            loadingValue: 0,
                            url: v,
                        });
                    }
                }
            },
            change(event) {
                for (let key in event.target.files) {
                    if (typeof event.target.files[key] !== 'object') continue;

                    let len = this.localValue.push({
                        file: event.target.files[key],
                        loading: true,
                        loadingValue: 0,
                        url: null
                    });

                    this.uploadFile(len-1);
                }
                this.model = null;
            },
            uploadFile(key) {

                let file = this.localValue[key].file;

                const reader = new FileReader();

                reader.readAsDataURL(file);

                this.$store.dispatch('uploadImage', {
                    file,
                    onUploadProgress: progressEvent => {
                        let percent = progressEvent.loaded * 100 / progressEvent.total;
                        this.localValue[key].loadingValue = Math.round(percent);
                    }
                })
                    .then(res => {
                        this.localValue[key].url = res.path;
                        this.sendValue();
                    })
                    .finally(() => this.localValue[key].loading = false);
            },
            sendValue() {
                let vals = [];

                this.localValue.forEach(item => {
                    if (item.url !== null) {
                        vals.push(item.url);
                    }
                });

                if (this.multiple) {
                    if (vals.length !== this.localValue.length) return;
                    this.$emit('input', vals);
                } else {
                    let url = null;
                    if (vals.length > 0) {
                        url = vals[0];
                    }
                    this.$emit('input', url);
                }
            }
        },
        created() {
            this.parseValue(this.value);
        }
    }
</script>

<style lang="scss">
    .input-file {
        &.input-file_mobile {
            .input-file__items {
                flex-direction: column;
            }
            .input-file__item {
                width: calc(100% - 10px) !important;
                height: inherit !important;
            }
        }
    }
    .input-file__items {
        display: flex;
        margin-left: -5px;
        margin-right: -5px;
    }
    .input-file__item {
        border: 1px solid #9e9e9e;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: 5px;
    }
    .input-file__img {
        max-width: 100%;
        max-height: 100%;
    }
    .input-file__close {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .input-file__msg {
        color: #ff5252 !important;
        font-size: 12px;
        padding: 3px 0px 0px 10px;
    }
</style>